import { StatusBar, StyleSheet } from "react-native";

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
        justifyContent: 'space-between'
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: 30,
        width: "90%",
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 30
    },
    headerRight: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    headerButton: {
        marginLeft: 20,
        marginRight: 10
    },
    textContainer: {
        width: '85%',
        marginRight: 'auto',
        marginLeft: 'auto',
        marginBottom: 20
    },
    text: {
        fontSize: 23,
        fontFamily: 'Lato_400Regular',
    }, 
    footer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 35 
    },
    footerText: {
        fontSize: 24,
        fontFamily: 'Montserrat_400Regular'
    }
});

export default styles;